module.exports = __webpack_public_path__ + "band_3.17d8757e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_3.png
// module id = 1jZE
// module chunks = 0